export default "__VITE_ASSET__Cz1r4NsP__"